import { useEffect, useRef } from "react";

export default function CanvasJungleScene() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = window.innerHeight);

    ctx.clearRect(0, 0, width, height);

    // Sky background
    ctx.fillStyle = "#A5D6A7";
    ctx.fillRect(0, 0, width, height);

    // Jungle floor
    ctx.fillStyle = "#81C784";
    ctx.fillRect(0, height * 0.7, width, height * 0.3);

    const drawTree = (x, y, trunkHeight) => {
      // Trunk
      ctx.fillStyle = "#6D4C41";
      ctx.fillRect(x - 20, y - trunkHeight, 40, trunkHeight);
      // Leaves
      ctx.beginPath();
      ctx.moveTo(x - 50, y - trunkHeight);
      ctx.lineTo(x, y - trunkHeight - 50);
      ctx.lineTo(x + 50, y - trunkHeight);
      ctx.closePath();
      ctx.fillStyle = "#388E3C";
      ctx.fill();
    };

    // Define x positions for trees
    const baseY = height * 0.7;
    const positions = [
      width * 0.15,
      width * 0.3,
      width * 0.42,
      width * 0.5, // center tree
      width * 0.58,
      width * 0.7,
      width * 0.85,
    ];

    const trunkHeights = [height * 0.21, height * 0.4,height * 0.25, height * 0.35, height * 0.28, height * 0.35, height * 0.4];

    for (let i = 0; i < positions.length; i++) {
      drawTree(positions[i], baseY, trunkHeights[i]);
    }

  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
    />
  );
}
